import {
  mdiClose,
  mdiCursorDefaultClickOutline,
  mdiDeleteOutline,
  mdiMagnifyMinusOutline,
  mdiMagnifyPlusOutline,
  mdiVectorPolygon,
} from "@mdi/js";
import { Icon } from "@mdi/react";

type IconProps = {
  className?: string;
};

export function ZoomInIcon({ className }: IconProps) {
  return (
    <Icon
      className={className}
      path={mdiMagnifyPlusOutline}
      style={{ stroke: "none" }}
    />
  );
}

export function ZoomOutIcon({ className }: IconProps) {
  return (
    <Icon
      className={className}
      path={mdiMagnifyMinusOutline}
      style={{ stroke: "none" }}
    />
  );
}

export function PolygonIcon({ className }: IconProps) {
  return (
    <Icon
      className={className}
      path={mdiVectorPolygon}
      style={{ stroke: "none" }}
    />
  );
}

export function ClearIcon({ className }: IconProps) {
  return (
    <Icon
      className={className}
      path={mdiDeleteOutline}
      style={{ stroke: "none" }}
    />
  );
}

export function IdentifyIcon({ className }: IconProps) {
  return (
    <Icon
      className={className}
      path={mdiCursorDefaultClickOutline}
      style={{ stroke: "none" }}
    />
  );
}

export function CloseIcon({ className }: IconProps) {
  return (
    <Icon className={className} path={mdiClose} style={{ stroke: "none" }} />
  );
}
